import React from 'react';
import { TagShapeProps } from '../utils/common-graph.utils';
import { GRID_UNIT_SIZE } from '../utils/graph.utils';

export const LaddergramSquare: React.FC<TagShapeProps> = ({
  color,
  bordered,
  size,
}) => {
  const offset = GRID_UNIT_SIZE;
  const innerSize = size / 2 - offset;
  return (
    <>
      {bordered && (
        <rect
          width={size}
          height={size}
          stroke='black'
          fill='transparent'
          strokeWidth={GRID_UNIT_SIZE / 2}
        />
      )}

      <g transform={`translate(${offset}, ${offset})`}>
        <rect width={innerSize * 2} height={innerSize * 2} fill={color} />
      </g>
    </>
  );
};
